// Get environment variables
const userPoolId = import.meta.env.VITE_AWS_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID;
const region = import.meta.env.VITE_AWS_COGNITO_REGION;
const cognitoDomain = import.meta.env.VITE_AWS_COGNITO_DOMAIN;

// Validate required environment variables
const missingVars: string[] = [];
if (!userPoolId) missingVars.push("VITE_AWS_USER_POOL_ID");
if (!userPoolClientId) missingVars.push("VITE_AWS_USER_POOL_CLIENT_ID");
if (!region) missingVars.push("VITE_AWS_COGNITO_REGION");
if (!cognitoDomain) missingVars.push("VITE_AWS_COGNITO_DOMAIN");

if (missingVars.length > 0) {
  console.error(
    "Missing required environment variables for Amplify Cognito configuration:",
    missingVars.join(", ")
  );
  console.error("Please ensure these variables are set in your .env.local file or environment.");
  throw new Error(`Missing required environment variables: ${missingVars.join(", ")}`);
}

// Build Amplify configuration with validated values
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: userPoolId as string,
      userPoolClientId: userPoolClientId as string,
      region: region as string,
      loginWith: {
        oauth: {
          domain: cognitoDomain as string,
          scopes: ["openid", "profile", "email"],
          redirectSignIn: [`${window.location.origin}/callback`],
          redirectSignOut: [`${window.location.origin}/logout`],
          responseType: "code" as const,
        },
      },
    },
  },
};
